import React from "react";
import { Route, Switch } from "react-router-dom";
import Footer from "../components/footer";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { activeToggle } from "../utils/helper";
import ProfilePersonalDetails from "../pages/hcp/UserProfile/ProfilePersonalDetails";
import ProfileProfessionalInfo from "../pages/hcp/UserProfile/ProfileProfessionalInfo";
import ProfileChangePassword from "../pages/hcp/UserProfile/ProfileChangePassword";
import { useUserProfile } from "../hooks/getUserProfile";
const UserProfileLayout = () => {
  const { data: userProfile, isLoading, refetch } = useUserProfile();

  return (
    <>
      <div className="container-fluid pt-12 pl-21 pb-12 pr-24 h-100 noScroll">
        <div className="card border-0 h-100">
          <div className="card-body mb-3">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="font-weight-lighter mb-0">User Profile</h5>
              <label className="small-text decoration-0">
                POMMe ID:{" "}
                <span className="ml-1">{userProfile?.data?.pommeId}</span>
              </label>
            </div>
            <hr />
            <div className="d-flex my-12">
              <Link
                to={"/hcp/profile/personal_details"}
                className={`btn btn-user-profile mr-2 ${
                  activeToggle("/hcp/profile/personal_details")
                    ? "btn-user-profile-active"
                    : ""
                }`}
              >
                Personal Details
              </Link>
              {/* <Link
                to={"/hcp/profile/professional_information"}
                className={`btn btn-user-profile mr-2 ${
                  activeToggle("/hcp/profile/professional_information")
                    ? "btn-user-profile-active"
                    : ""
                }`}
              >
                Professional Information
              </Link> */}
              <Link
                to={"/hcp/profile/change_password"}
                className={`btn btn-user-profile mr-2 ${
                  activeToggle("/hcp/profile/change_password")
                    ? "btn-user-profile-active"
                    : ""
                }`}
              >
                Change Password
              </Link>
            </div>
            <hr />
            <div className="noScroll h-90 px-35">
              <Switch>
                <Route
                  path="/hcp/profile/personal_details"
                  component={ProfilePersonalDetails}
                />
                <Route
                  path="/hcp/profile/professional_information"
                  component={ProfileProfessionalInfo}
                />
                <Route
                  path="/hcp/profile/change_password"
                  component={ProfileChangePassword}
                />
              </Switch>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UserProfileLayout;
